export const SET_SEARCH_CODE = 'SET_SEARCH_CODE';
